import { InteractionType } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react';
import { AuthInProgress } from 'context-providers';
import { PropsWithChildren } from 'react';

export function ProtectedRoute({ children }: PropsWithChildren<{}>) {
  useMsalAuthentication(InteractionType.Redirect);
  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <AuthInProgress />;
      </UnauthenticatedTemplate>
    </>
  );
}
